export default "<app-navbar *ngIf=\"!hideNav\"></app-navbar>\n\n<router-outlet></router-outlet>\n\n<app-footer></app-footer>"